
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Es gibt Menschen, die zwingen sich, auf der richtigen Seite einzuschlafen. Richtig heisst in ihrem Fall: links. Denn das entlastet angeblich das Herz. Die Begründung ist pure Anatomie: Die Hauptschlagader macht oberhalb des Herzen eine Linkskurve. Deshalb muss das Blut im Liegen einen kurzen Moment bergauf fliessen. Die Befürchtung: Das Herz müsse in der Nacht härter arbeiten. `}<br /><br />{`
Doch wer aufgepasst hat im Biologie-Unterricht, der weiss: `}<M mdxType="M">{`Das Herz ist ein starkes Pumporgan.`}</M>{` Eine kleine Kurve von wenigen Zentimetern macht dem Herzen keine Probleme – schon gar nicht im Schlaf. Würde es dem Herzen und den Gefässen nicht gelingen, Blut entgegen der Schwerkraft zu befördern, würde kein Sauerstoff im Gehirn ankommen. Das ist glücklicherweise nicht der Fall.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;